var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var Button = /** @class */ (function () {
    function Button() {
        this.node = document.createElement('button');
        this.node.style.padding = '5px';
        this.node.type = 'button';
        this.icon = null;
    }
    Button.prototype.setIcon = function (icon) {
        this.icon = icon;
        this.node.appendChild(icon);
    };
    Button.prototype.setText = function (text) {
        this.node.textContent = text;
    };
    Button.prototype.onClick = function (callback) {
        this.node.addEventListener('click', callback);
    };
    Button.prototype.addClassName = function (className) {
        this.node.classList.add(className);
    };
    Button.prototype.removeClassName = function (className) {
        this.node.classList.remove(className);
    };
    return Button;
}());
var Base = /** @class */ (function () {
    function Base() {
        this.node = document.createElement('div');
        this.node.classList.add('mapboxgl-ctrl');
        this.node.classList.add('mapboxgl-ctrl-group');
        this.node.classList.add('mapbox-control');
    }
    Base.prototype.addButton = function (button) {
        this.node.appendChild(button.node);
    };
    Base.prototype.addClassName = function (className) {
        this.node.classList.add(className);
    };
    Base.prototype.removeClassName = function (className) {
        this.node.classList.remove(className);
    };
    Base.prototype.onAddControl = function () {
        // extend
    };
    Base.prototype.onRemoveControl = function () {
        // extend
    };
    Base.prototype.onAdd = function (map) {
        this.map = map;
        this.onAddControl();
        return this.node;
    };
    Base.prototype.onRemove = function () {
        this.onRemoveControl();
        this.node.parentNode.removeChild(this.node);
        this.map = null;
    };
    return Base;
}());
var svgIcon = "<svg viewBox=\"0 0 512.00533 512\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"m10.671875 170.667969c-5.886719 0-10.66796875-4.777344-10.66796875-10.664063v-149.335937c0-5.886719 4.78124975-10.66406275 10.66796875-10.66406275h149.332031c5.890625 0 10.667969 4.77734375 10.667969 10.66406275 0 5.890625-4.777344 10.667969-10.667969 10.667969h-138.664062v138.667968c0 5.886719-4.78125 10.664063-10.667969 10.664063zm0 0\"/><path d=\"m501.339844 170.667969c-5.890625 0-10.667969-4.777344-10.667969-10.664063v-138.667968h-138.667969c-5.886718 0-10.664062-4.777344-10.664062-10.667969 0-5.886719 4.777344-10.66406275 10.664062-10.66406275h149.335938c5.886718 0 10.664062 4.77734375 10.664062 10.66406275v149.335937c0 5.886719-4.777344 10.664063-10.664062 10.664063zm0 0\"/><path d=\"m160.003906 512.003906h-149.332031c-5.886719 0-10.66796875-4.78125-10.66796875-10.667968v-149.332032c0-5.890625 4.78124975-10.667968 10.66796875-10.667968s10.667969 4.777343 10.667969 10.667968v138.664063h138.664062c5.890625 0 10.667969 4.78125 10.667969 10.667969 0 5.886718-4.777344 10.667968-10.667969 10.667968zm0 0\"/><path d=\"m501.339844 512.003906h-149.335938c-5.886718 0-10.664062-4.78125-10.664062-10.667968 0-5.886719 4.777344-10.667969 10.664062-10.667969h138.667969v-138.664063c0-5.890625 4.777344-10.667968 10.667969-10.667968 5.886718 0 10.664062 4.777343 10.664062 10.667968v149.332032c0 5.886718-4.777344 10.667968-10.664062 10.667968zm0 0\"/><path d=\"m181.339844 192.003906c-2.730469 0-5.460938-1.046875-7.554688-3.117187l-170.664062-170.664063c-4.160156-4.160156-4.160156-10.925781 0-15.085937 4.160156-4.15625 10.921875-4.15625 15.082031 0l170.667969 170.667969c4.160156 4.160156 4.160156 10.921874 0 15.082031-2.070313 2.070312-4.800782 3.117187-7.53125 3.117187zm0 0\"/><path d=\"m330.671875 192.003906c-2.730469 0-5.460937-1.046875-7.550781-3.117187-4.160156-4.160157-4.160156-10.921875 0-15.082031l170.664062-170.667969c4.160156-4.15625 10.925782-4.15625 15.085938 0 4.160156 4.160156 4.160156 10.925781 0 15.085937l-170.667969 170.664063c-2.070313 2.070312-4.800781 3.117187-7.53125 3.117187zm0 0\"/><path d=\"m501.339844 512.003906c-2.730469 0-5.460938-1.046875-7.554688-3.117187l-170.664062-170.664063c-4.160156-4.160156-4.160156-10.925781 0-15.085937 4.160156-4.15625 10.921875-4.15625 15.082031 0l170.667969 170.667969c4.160156 4.160156 4.160156 10.921874 0 15.082031-2.070313 2.070312-4.800782 3.117187-7.53125 3.117187zm0 0\"/><path d=\"m10.671875 512.003906c-2.730469 0-5.460937-1.046875-7.550781-3.117187-4.160156-4.160157-4.160156-10.921875 0-15.082031l170.664062-170.667969c4.160156-4.15625 10.925782-4.15625 15.085938 0 4.160156 4.160156 4.160156 10.925781 0 15.085937l-170.667969 170.664063c-2.070313 2.070312-4.800781 3.117187-7.53125 3.117187zm0 0\"/></svg>";
var ZoomControl = /** @class */ (function (_super) {
    __extends(ZoomControl, _super);
    function ZoomControl(onClick) {
        var _this = _super.call(this) || this;
        _this.onClick = onClick;
        _this.zoom = new Button();
        return _this;
    }
    ZoomControl.prototype.insert = function () {
        var _this = this;
        var icon = new DOMParser().parseFromString(svgIcon, 'image/svg+xml')
            .firstChild;
        this.addClassName('mapbox-zoom');
        this.zoom.setIcon(icon);
        this.zoom.onClick(function () { return _this.onClick(); });
        this.addButton(this.zoom);
    };
    ZoomControl.prototype.onAddControl = function () {
        this.insert();
    };
    return ZoomControl;
}(Base));
export { ZoomControl };
